import "common/assets/css/text-editor.css";
import { Box, Text } from "@chakra-ui/react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { useMemo } from "react";
import CustomToolbar from "./component/CustomToolBar";
import { textEditorInfo } from "common/data/textEditor";
import { globalStyles } from "common/theme/styles";

const TextEditor = ({ toolbarId = "toolbar", value, errorMsg, handleChange, handleBlur, borderColor }) => {
    const colors = globalStyles.colors;

    const modules = useMemo(() => ({
        toolbar: {
            container: `#${toolbarId}`,
            handlers: {
                undo: function () {
                    this.quill.history.undo();
                },
                redo: function () {
                    this.quill.history.redo();
                },
            },
        },
        history: {
            delay: 2000,
            maxStack: 500,
            userOnly: true,
        },
    }), []);

    return (
        <Box p={'0px'} w="100%">
            <CustomToolbar toolbarId={toolbarId} />
            <ReactQuill
                borderColor={borderColor}
                theme="snow"
                name={toolbarId}
                value={value && value}
                onChange={handleChange && handleChange}
                onBlur={handleBlur && handleBlur}
                modules={modules}
                formats={textEditorInfo.textEditorFormat}
            />
            {errorMsg && errorMsg.length > 0 &&
                <Text color={colors.errorText} ></Text>
            }
        </Box>
    );
};

export default TextEditor;
